import axios from 'axios';

import {
    API_URL_SUPPLIER_COMPANY_INFO_AI
} from '../../constants/index';

export default class SupplierCompanyInfoAiService {
    static instance;

    static getInstance() {
        if (!SupplierCompanyInfoAiService.instance) {
            SupplierCompanyInfoAiService.instance = new SupplierCompanyInfoAiService();
        }

        return SupplierCompanyInfoAiService.instance;
    }

    async fetchCompanyInfo(payload) {
        const response = await axios.post(API_URL_SUPPLIER_COMPANY_INFO_AI, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                )}`,
            },
        });

        return response.data;
    }
}
